<script setup>
import { Comment, computed, useSlots } from "vue";

const slots = useSlots();
const isVisible = computed(() => slots.default && slots.default().findIndex((o) => o.type !== Comment) !== -1);
</script>

<template>
	<div class="notify">
		<Transition
			enter-active-class="animate__animated animate__bounceInDown"
			leave-active-class="animate__animated animate__bounceOutUp"
		>
			<div v-if="isVisible" class="notify-item card-16">
				<slot></slot>
			</div>
		</Transition>
	</div>
</template>
